/**
 * <PosterCard />
 *
 * @parent PosterList
 * @stateless
 */
import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';

import { STATE } from 'controllers/poster/updatePoster';
import moment from 'moment';
import BackgroundImage from 'react-background-image-loader';
import ShareOnSocialMedia from 'template/Modals/ShareOnSocialMedia';
import { browserHistory } from 'react-router';
import locale from './locale';
import './PosterCard.scss';
import { MOMENT_LOCALE } from 'constants';
import {alert} from 'util/alert'

import {updatePoster} from '../ducks'
import __R from 'containers/__R';

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => {
  return {
    updatePoster: (index, posterId, posterInfo, callback) => dispatch(updatePoster(index, posterId, posterInfo, callback)),
	}
}

class PosterCard extends React.Component {

  constructor(props) {
    super(props);
    this.posterTypeVerbose = [
      __('Enrollment Registration', 'poster.type'),
      __('Event Registration', 'poster.type'),
      __('Survey', 'poster.type'),
      __('Basic Poster', 'poster.type'),
    ];
    this.posterStateVerbose = [__('Draft', 'poster'), __('Published', 'poster'), __('Closed', 'poster')];
  }

  getPageUrl(id) {
    const language = localStorage.getItem('language');

    if (process.env.NODE_ENV === 'development') {
      return `https://posterdev.classtop.com/${id}?language=${language}`;
    } else {
      return `https://poster.classtop.com/${id}?language=${language}`;
    }
  }

  render() {
    const {onDelete, onUnlink, poster, index} = this.props;
    const {
      id,
      title,
      state,
      poster_type,
      cover_image,
      updated_at,
      has_order
    } = poster;

    let ticket_amount = poster.order_ticket_total_amount
    if(ticket_amount == null){
      ticket_amount = 0
    }

    const stateVerbose = STATE[state];
    const localeCode = localStorage.getItem('language');
    const dateMoment = moment(updated_at).locale(MOMENT_LOCALE[localeCode] || 'en').format(__('ddd, MMM DD YYYY', locale));
    return (
      <div className='poster-card-wrapper'>
        <div className='poster-card'>
          <__R can={state === 0 ? 'edit_poster' : 'poster_channel'} by="alert" >
            <a href={state === 1 ? `poster-preview/${id}` : `edit-poster/${id}`} target={ state === 1 ? '_blank' : ''} onClick={(e) => {
              if(has_order && state !== 1){
                e.preventDefault();
                alert.warning(__('You cannot edit poster that has been registered', locale))
              }
            }}>
              <div className='poster-content'>
                <span className={classnames('poster-state', { 'draft': state === 0, 'published': state === 1 })}>{this.posterStateVerbose[state]}</span>
                <div className='poster-type'>{this.posterTypeVerbose[poster_type]}</div>
                <div className='image-wrapper'>
                  <div className='image-overlay'></div>
                  <BackgroundImage src={cover_image} className='image' />
                </div>
                <div className='date'>{dateMoment}</div>
                <div className={classnames('title', { 'draft': state === 0, 'published': state === 1 })}>{title}</div>
              </div>
            </a>
          </__R>

          <div className='setting-section'>
            <div className='setting-content'>
              {poster_type !== 3 && <div className='card-button' onClick={() => {browserHistory.push(`/registration-table/${id}`)}}>{__('Registered: ', locale)}{__('{ticket_amount}', locale, { ticket_amount })}</div>}
              {
                stateVerbose != 'closed' &&
                <__R can={state === 0 ? 'edit_poster' : 'poster_channel'} by='alert'>
                  <div className={state === 0 ? 'draft' : 'published'} onClick={() => {
                    if(stateVerbose == 'draft'){
                      this.props.updatePoster(index, id, {state: 'published'}, ()=> {
                        this.props.onFetch()
                      })
                    }
                  }}>
                  {state === 0 ? __('Publish', locale) : __('Published', locale)}
                  </div>
                </__R>
              }
              { state !== 1 &&
                <__R can='edit_poster' by='alert'>
                  <button className='btn-link poster-button' onClick={onDelete(id)}>{__('Delete', locale)}</button>
                </__R>
              }
              { state === 1 &&
                <__R can='edit_poster' by='alert'>
                  <button className='btn-link poster-button' onClick={onUnlink(id)}>{__('Close', locale)}</button>
                </__R>
              }
              { state === 1 && <button className='btn-link poster-button' onClick={()=>{ ShareOnSocialMedia({ pageUrl: this.getPageUrl(id), pageTitle: title, }); }}>{__('Share', locale)}</button> }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PosterCard);



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/PosterList/PosterCard.js